import styled from "styled-components";
import { Avatar as AvatarBui } from "discover.medical.react-component-library";

export const Avatar = styled(AvatarBui)`
  cursor: pointer;
`;
